import React, { useState, useEffect } from "react";
import lija7 from "../asets/lija7.jpg"; 
import izlog from "../asets/izlog.jpg";
import '../App.css';

function Lokacija() {
  const [backgroundImage, setBackgroundImage] = useState(izlog);
  const [showMobileImage, setShowMobileImage] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= 768;
      setBackgroundImage(isMobile ? lija7 : izlog);
      setShowMobileImage(isMobile);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="font" 
      style={{
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "130vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      }}
    >
      <div className="container mt-4"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <div className="text-center mb-5">
           <h2 className="section-title text-uppercase">Lokacija naše škole</h2>
        </div>

        {/* Kontakt informacije */}
        <div className="mb-4">
          <h4 className="section-subtitle text-center">Knjaza Miloša 144, 34300 Aranđelovac</h4>
        </div>

        {/* Mapa */}
        <div style={{ width: "100%", maxWidth: "800px", marginTop: "20px" }}>
          <iframe
            title="Mapa lokacije škole"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d178.5978274137721!2d20.681380004014397!3d44.257189724672386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47574b8f20986185%3A0x136890f5f0dfbc6a!2sHappy%20Kids%20Center!5e0!3m2!1ssr!2srs!4v1706109770033!5m2!1ssr!2srs"
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: "10px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        {/* Slika ispod mape samo na mobilnim uređajima */}
        {showMobileImage && (
          <img 
            src={izlog} 
            alt="Izlog" 
            style={{ 
              marginTop: "20px", 
              width: "100%", 
              maxWidth: "800px", 
              borderRadius: "10px" 
            }} 
          />
        )}
      </div>
    </div>
  );
}

export default Lokacija;
